import React, { Component } from 'react';
//import React, { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Secured from './components/Secured/Secured';
import PrivacyPolicyContents from './components/PrivacyPolicy/PrivacyPolicyContents';
import EulaContents from './components/Eula/EulaContents';
import ContactUsContents from './components/ContactUs/ContactUsContents';
import TermsOfUseContents from './components/TermsOfUse/TermsOfUseContents';
import AuthenticatedTemplate from './components/AuthenticatedTemplate/AuthenticatedTemplate';
import UnauthenticatedTemplate from './components/UnauthenticatedTemplate/UnauthenticatedTemplate';
import Login from './components/Login/Login';
import Logout from './components/Logout/Logout';
import Landing from './components/Landing/Landing';
//import Loading from './components/Loading/Loading';
import { EnvironmentProvider } from './contexts/EnvironmentContext';
import { AdminProvider } from './contexts/AdminContext';
//import { msalConfig, b2cPolicies } from './authConfig';
//import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
//import { EventType } from '@azure/msal-browser';



import './styles/main.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faRedoAlt, faArrowRight, faStopwatch, faCircle, faGrin as faGrinSolid, faMinus, faBan, faColumns, faSpinner, faSlidersH, faCog, faSitemap, faBriefcase, faSatelliteDish, faUserSlash, faUserCheck, faChevronCircleDown, faUsers, faUpload, faArrowUp, faArrowDown, faCheckCircle, faCertificate, faTimesCircle, faMinusCircle, faCommentSlash, faTimes, faComment, faCheck, faPlus, faSyncAlt, faExternalLinkAlt, faGlobe, faHome, faPlusCircle, faUserTie, faSignOutAlt, faBars, faFile, faEnvelope, faUser, faSearch, faChevronDown, faCalendarAlt, faUserMd, faExclamationTriangle, faClipboardCheck, faClipboardList, faComments, faVideo, faEllipsisH, faChevronLeft, faChevronRight, faCogs, faInfoCircle, faMapMarkerAlt, faPhone, faLink, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faInstagram, faTwitterSquare, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faUser as faUserRegular, faGrinBeam, faSmile, faGrin, faMeh, faFrown, faAngry, faSadTear, faSquare, faCheckSquare } from '@fortawesome/free-regular-svg-icons';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse/TermsOfUse';
import Eula from './components/Eula/Eula';
library.add(faRedoAlt, faArrowRight, faStopwatch, faCircle, faGrinSolid, faMinus, faBan, faColumns, faSpinner, faSlidersH, faCog, faSitemap, faBriefcase, faSatelliteDish, faUserSlash, faUserCheck, faChevronCircleDown, faUsers, faUpload, faArrowUp, faArrowDown, faCheckCircle, faCertificate, faTimesCircle, faMinusCircle, faCommentSlash, faTimes, faComment, faCheck, faPlus, faSyncAlt, faExternalLinkAlt, faGlobe, faHome, faPlusCircle, faUserTie, faInstagram, faTwitterSquare, faFacebook, faSignOutAlt, faBars, faFile, faEnvelope, faUser, faSearch, faChevronDown, faCalendarAlt, faUserMd, faExclamationTriangle, faClipboardCheck, faClipboardList, faComments, faVideo, faEllipsisH, faChevronLeft, faChevronRight, faCogs, faInfoCircle, faMapMarkerAlt, faPhone, faLink, faEye, faEyeSlash);
library.add(faUserRegular, faLinkedin, faGrinBeam, faSmile, faGrin, faMeh, faFrown, faAngry, faSadTear, faSquare, faCheckSquare);

//const Pages = () => {
//    /**
//     * useMsal is hook that returns the PublicClientApplication instance,
//     * an array of all accounts currently signed in and an inProgress value
//     * that tells you what msal is currently doing. For more, visit:
//     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
//     */
//    const { instance } = useMsal();
//    useEffect(() => {
//        const callbackId = instance.addEventCallback((event) => {
//            //if (
//            //    (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
//            //    event.payload.account
//            //) {
//            //    /**
//            //     * For the purpose of setting an active account for UI update, we want to consider only the auth
//            //     * response resulting from SUSI flow. "tfp" claim in the id token tells us the policy (NOTE: legacy
//            //     * policies may use "acr" instead of "tfp"). To learn more about B2C tokens, visit:
//            //     * https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
//            //     */
//            //    if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.editProfile)) {
//            //        // retrieve the account from initial sing-in to the app
//            //        const originalSignInAccount = instance
//            //            .getAllAccounts()
//            //            .find(
//            //                (account) =>
//            //                    account.idTokenClaims.oid === event.payload.idTokenClaims.oid &&
//            //                    account.idTokenClaims.sub === event.payload.idTokenClaims.sub &&
//            //                    compareIssuingPolicy(account.idTokenClaims, b2cPolicies.names.signUpSignIn)
//            //            );

//            //        let signUpSignInFlowRequest = {
//            //            authority: b2cPolicies.authorities.signUpSignIn.authority,
//            //            account: originalSignInAccount,
//            //        };

//            //        // silently login again with the signUpSignIn policy
//            //        instance.ssoSilent(signUpSignInFlowRequest);
//            //    }

//            //    /**
//            //     * Below we are checking if the user is returning from the reset password flow.
//            //     * If so, we will ask the user to reauthenticate with their new password.
//            //     * If you do not want this behavior and prefer your users to stay signed in instead,
//            //     * you can replace the code below with the same pattern used for handling the return from
//            //     * profile edit flow
//            //     */
//            //    if (compareIssuingPolicy(event.payload.idTokenClaims, b2cPolicies.names.forgotPassword)) {
//            //        let signUpSignInFlowRequest = {
//            //            authority: b2cPolicies.authorities.signUpSignIn.authority,
//            //            scopes: [
//            //                ...protectedResources.apiTodoList.scopes.read,
//            //                ...protectedResources.apiTodoList.scopes.write,
//            //            ],
//            //        };
//            //        instance.loginRedirect(signUpSignInFlowRequest);
//            //    }
//            //}

//            if (event.eventType === EventType.LOGIN_FAILURE) {
//                // Check for forgot password error
//                // Learn more about AAD error codes at https://docs.microsoft.com/en-us/azure/active-directory/develop/reference-aadsts-error-codes
//                const forgotPasswordErrorCode = 'AADB2C90118';
//                const userCancelledErrorCode = 'AADB2C90091';

//                if (event.error && event.error.errorMessage.includes(forgotPasswordErrorCode)) {
//                    const resetPasswordRequest = {
//                        authority: b2cPolicies.authorities.resetPassword.authority,
//                        scopes: [],
//                    };
//                    instance.loginRedirect(resetPasswordRequest);
//                }
//                if (event.error && event.error.errorMessage.includes(userCancelledErrorCode)) {

//                    instance.signOut();
//                }
//            }
//        });

//        return () => {
//            if (callbackId) {
//                instance.removeEventCallback(callbackId);
//            }
//        };
//        // eslint-disable-next-line
//    }, [instance]);

//    return (
//        <div>
//            <AuthenticatedTemplate>
//                <EnvironmentProvider>
//                    <AdminProvider>
//                        <Routes>
//                            <Route exact path="/" element={<Secured />} />
//                            <Route exact path="/logout" element={<Logout />} />
//                        </Routes>
//                    </AdminProvider>
//                </EnvironmentProvider>
//            </ AuthenticatedTemplate>
//            <UnauthenticatedTemplate>
//                <EnvironmentProvider>
//                    <AdminProvider>
//                        <Routes>
//                            <Route exact path="/" element={<Landing />} />
//                        </Routes>
//                    </AdminProvider>
//                </EnvironmentProvider>
//            </ UnauthenticatedTemplate>
//        </div>
//    );
//};

///**
// * msal-react is built on the React context API and all parts of your app that require authentication must be
// * wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication
// * then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the
// * PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
// * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
// */
//const App = ({ instance }) => {
//    //var instance = new PublicClientApplication(msalConfig);
//    return (

//        <MsalProvider instance={instance}>
//            <Pages />
//        </MsalProvider>
//    );
//};

//export default App;

export default function App() {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <Routes>
          <Route path="/*" element={<Secured />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/privacy" element={<PrivacyPolicyContents />} />
          <Route path="/terms" element={<TermsOfUseContents />} />
          <Route path="/eula" element={<EulaContents />} />
          <Route path="/contactus" element={<ContactUsContents />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Routes>
          <Route path="/*" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicyContents />} />
          <Route path="/terms" element={<TermsOfUseContents />} />
          <Route path="/eula" element={<EulaContents />} />
          <Route path="/contactus" element={<ContactUsContents />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </UnauthenticatedTemplate>

    </div>
  );

}
//export default class App extends Component {
//    static displayName = App.name;
//    render() {
//        return (
//          <div className="App">
//                <AuthenticatedTemplate>
//                  <Routes>
//                    <Route path="/" element={<Secured />} />
//                    <Route path="/logout" element={<Logout />} />
//                    <Route element={<Secured />} />
//                  </Routes>
//                </AuthenticatedTemplate>
//                <UnauthenticatedTemplate>
//                  <Routes>
//                    <Route path="/" element={<Landing />} />
//                    <Route path="/login" element={<Login />} />
//                    <Route element={<Navigate to="/" />} />
//                  </Routes>
//                </UnauthenticatedTemplate>

//          </div>
//    );
//  }
//}


//TODO:  Remove once b2c works with access token

//export default class App extends Component {
//  static displayName = App.name;
//  static contextType = MsalContext;
//    render() {
//        var instance = new PublicClientApplication(msalConfig);

//        return (
//        <MsalProvider instance={instance}>
//            <AuthenticatedTemplate>
//                <EnvironmentProvider>
//                    <AdminProvider>
//                        <Routes>
//                            <Route exact path="/" element={<Secured />} />
//                            <Route exact path="/logout" element={<Logout />} />
//                        </Routes>
//                    </AdminProvider>
//                </EnvironmentProvider>
//            </ AuthenticatedTemplate>
//            <UnauthenticatedTemplate>
//                <EnvironmentProvider>
//                    <AdminProvider>
//                        <Routes>
//                            <Route exact path="/" element={<Landing />} />
//                        </Routes>
//                    </AdminProvider>
//                </EnvironmentProvider>
//            </ UnauthenticatedTemplate>
//        </MsalProvider>
//    );
//  }
//}
